import FetchService from "./FetchService";
import FilterService from "./FilterService";
// Private static variables
const baseUrl = "/aviso/advisor/";
export default class AdvisorService {
    /**
     * Search for people using the allStudents filter
     *
     * @param {string} query - the query string to use in the filter
     * @param {number} [maxPeople=50] - the max number of people to return
     */
    static searchUsingFilter(query, maxPeople = 50) {
        return FilterService.getAllStudentsFilterId().then((filterId) => FetchService.getPagedResponse(baseUrl + "getStudentList", {
            filterId,
            q: query,
            maxRows: maxPeople,
        }));
    }
}
